<template>
  <header class="ecl-site-header" data-ecl-auto-init="SiteHeader">
    <header-page-information/>
    <div class="ecl-site-header__header">
      <div class="ecl-site-header__container ecl-container">
        <div class="ecl-site-header__top"><img
            alt="European Commission logo" title="European Commission"
            class="header-logo"
            src="https://ec.europa.eu/component-library/dist/media/logo-eu--en.81e214d9.svg" />
          <div class="ecl-site-header__action">
           
                <!-- <svg class="ecl-icon ecl-icon--s ecl-site-header__icon" focusable="false" aria-hidden="true">
                  <use xlink:href="@/../node_modules/@ecl/preset-ec/dist/images/icons/sprites/icons.svg#language" />
                </svg> -->
                <img src="../../assets/global.svg" height="24px">
                <span class="ecl-site-header__language-code">en</span>
                <span class="lang-select">English</span>
         
          </div>
        </div>
      </div>
    </div>
    <div class="header-bottom">
      <div class="ecl-container">
        <div class="ecl-site-header__site-name">
          <div class="pb-3 headline-wrap w-100">
              <div class="headline-wrap-inside">
                <div class="toplineHead">European data</div>
                <div class="headwrapLeft">
                  <h1 class="deu-headline m-0">data.europa.eu</h1><span class="d-none ml-3 d-md-inline"> The official portal
                    for
                    European
                    data</span>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import HeaderPageInformation from "@/components/header/HeaderPageInformation";
export default {
  name: "Header",
  components: {HeaderPageInformation}
}
</script>

<style scoped>
.header-logo{
  height: 45px;
  width: 159px;
}

.header-bottom {
  border-bottom: solid 6px #F2718A;
  margin-bottom: 10px;
}

.ecl-link:hover {
  color: #0E47CB !important
}
</style>
